import styles from "../../styles/_sections/_mainAttractionDetail/details.module.scss";

const Details = () => {
  return (
    <div className={styles.container}>
      <div className={styles.right}>
        <h3>Main Attraction Image</h3>

        <div className={styles.imgWrapper}>
          <img
            src="/assets/deleteIcon.png"
            alt="delete"
            className={styles.deleteIcon}
          />
          <div
            style={{ backgroundImage: "url('/assets/attraction-pic.jpg')" }}
            className={styles.mainImg}
          />
          <div className={styles.choose}>
            <p>Choose an image for the attraction</p>
          </div>
        </div>
      </div>

      <div className={styles.left}>
        <h3>Main Attraction Detail</h3>

        <div className={styles.field}>
          <label>Title</label>
          <input type="text" name="title" />
        </div>

        <div className={styles.field}>
          <label>Description</label>
          <textarea name="content"></textarea>
        </div>
      </div>
    </div>
  );
};

export default Details;
